export const getCurrentFilters = (context, route) => {
  const allFiltersContext = {
    processExplorerFilters: {
      variants: context.state.processExplorerVariants?.length ? context.state.processExplorerVariants : undefined,
      filters: context.state.processExplorerFilters?.length ? context.state.processExplorerFilters : undefined,
      active_variants: context.state.processExplorerActiveVariants?.length ? context.state.processExplorerActiveVariants : undefined ,
      flow: context.state.processExplorerFlow?.length ? context.state.processExplorerFlow : undefined,
      metrics: context.state.processExplorerMetrics?.length ? context.state.processExplorerMetrics : undefined,
    },
    variantExplorerFilters: {
      variants: context.handleAutoSave().processMapVariants,
      filters: context.handleAutoSave().processMapFilters,
      active_variants: context.state && context.state.activeVariantsProcessMap,
      flow: context.handleAutoSave().processMapFlow,
      metrics: context.handleAutoSave().processMapMetrics,
      advanced_activity_filters: context.handleAutoSave().processMapAdvancedActivityFilters,
    },
    processCompareFilters: {
      variants: context.handleAutoSave().processCompareVariants,
      filters: context.handleAutoSave().processCompareFilters,
      active_variants: context.state.activeVariantsProcessCompare,
      flow: context.handleAutoSave().processCompareFlow,
      metrics: context.handleAutoSave().processCompareMetrics,
      advanced_activity_filters: context.handleAutoSave().processCompareAdvancedActivityFilters1,
    },
    dataAnalysisFilters: {
      variants: context.handleAutoSave().dataAnalysisVariants,
      filters: context.handleAutoSave().dataAnalysisFilters,
      active_variants: context.handleAutoSave().dataAnalysisActiveVariants,
      flow: context.handleAutoSave().dataAnalysisFlow,
      metrics: context.handleAutoSave().dataAnalysisMetrics,
      advanced_activity_filters: context.handleAutoSave().dataAnalysisAdvancedActivityFilters,
    },
    generateBpmnModelFilters: {
      variants: context.handleSaveGenerateBpmnFilters().variants,
      filters: context.handleSaveGenerateBpmnFilters().filters,
      active_variants: context.handleSaveGenerateBpmnFilters().activeVariants,
      flow: context.handleSaveGenerateBpmnFilters().flow,
      metrics: context.handleSaveGenerateBpmnFilters().metrics,
      advanced_activity_filters: context.handleSaveGenerateBpmnFilters().advancedActivityFilters,
    },
    conformanceCheckingFilters: {
      variants:  context.state.conformanceCheckingVariants,
      filters: context.state.conformanceCheckingFilters,
      active_variants: context.state.conformanceCheckingActiveVariants,
      flow: context.state.conformanceCheckingFlow,
      metrics: context.state.conformanceCheckingMetrics,
      advanced_activity_filters: context.state.conformanceCheckingAdvancedActivityFilters,
    }
  }

  switch (route) {
    case "/process-explorer":
      return { ...allFiltersContext.processExplorerFilters }
    case "/variant-explorer":
      return { ...allFiltersContext.variantExplorerFilters }
    case "/process-compare":
      return { ...allFiltersContext.processCompareFilters }
    case "/data-analysis":
      return { ...allFiltersContext.dataAnalysisFilters }
    default:
      return undefined
  }
}